/**
 * Perioden innerhalb einer Timeline.
 *
 * @class service_v3sPeriodService
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').factory('v3sPeriodService', ["v3sTimelineService", "v3sConditionService", function (v3sTimelineService, v3sConditionService) {
	/**
	 * Ordnet die Aktionen einer Periode der Timeline zu.

	 * @memberOf v3sWbtPlayerApp:animation.service_v3sPeriodService
	 * @param {Object} period - Periode
	 */
	function addPeriod(period) {
	    if (!!period.items) {
	        v3sConditionService.addPeriod(period);
		} else {
		    v3sTimelineService.addPeriod(period);
		}
	}

	return {
		addPeriod: addPeriod
	};
}]);
